/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { QtdEmployeesOption, QtdEmployeesOptions } from 'services/qtd_employees';
import { AverageBillingOption, AverageBillingOptions } from 'services/average_billing';
import { ExperienceBiddingOptions, ExperienceBiddingOption } from 'services/experience_bidding';
import {
  GovernmentSalePercentageOptions,
  GovernmentSalePercentageOption,
} from 'services/government_sale_percentage';
import Select from 'react-select';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { useSelector, useDispatch } from 'react-redux';
import { UpdateRegisterExperient } from 'services/actions/update_register_beginner';
import { PanelState, PanelTypes } from 'store/modules/panel_store/types';

const ExperientRegisterModal = () => {
  const dispatch = useDispatch();
  const [qtdEmployees, setQtdEmployees] = useState<Array<QtdEmployeesOption>>([]);
  const [averageBilling, setAverageBilling] = useState<Array<AverageBillingOption>>([]);
  const [experienceBidding, setExperienceBidding] = useState<Array<ExperienceBiddingOption>>([]);
  const [governmentSale, setGovernmentSale] = useState<Array<GovernmentSalePercentageOption>>([]);
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);
  const [disableButton, setDisableButton] = useState<boolean>(true);
  const [msgErro, setMsgErro] = useState<boolean>(false);

  useEffect(() => {
    qtdEmployees.length !== 0 &&
      averageBilling.length !== 0 &&
      experienceBidding.length !== 0 &&
      governmentSale.length !== 0 &&
      setDisableButton(false);
  });

  const handleClick = async () => {
    const params = {
      employee_quantity: qtdEmployees,
      averageBilling,
      experienceBidding,
      governmentSale,
    };
    (async () => {
      const request = await UpdateRegisterExperient(params);
      request?.status === 200
        ? dispatch({
            type: PanelTypes.UPDATE_STATUS_REGISTER_EXPERIENT_MODAL,
            status_modal_experient: false,
          })
        : setMsgErro(true);
    })();
  };

  return (
    <Modal show={panel?.view_modal_experient_status && !panel?.view_modal_experient}>
      <div className="container">
        <div className="col-md-12">
          {profile?.consultant_login && (
            <button
              type="button"
              className="close"
              aria-label="Close"
              onClick={() =>
                dispatch({
                  type: PanelTypes.UPDATE_STATUS_REGISTER_EXPERIENT_MODAL,
                  status_modal_experient: false,
                })
              }
            >
              <span aria-hidden="true">&times;</span>
            </button>
          )}
          <h3 className="mt-3">Olá, {profile?.name}</h3>
          <p>Boas vindas ao ConLicitação!</p>
          <p className="mb-3">Conte um pouco sobre sua experiência e seus objetivos.</p>
          <div className="row mb-3">
            <div className="col-md-12">
              <label htmlFor="qtd_funcionario" className="m-0">
                Qual sua experiência nas licitações?
              </label>
              <Select
                name="qtd_funcionario"
                closeMenuOnSelect
                options={ExperienceBiddingOptions}
                noOptionsMessage={() => 'Selecione uma opção'}
                placeholder=""
                onChange={(selected) => {
                  setExperienceBidding(selected?.label as any);
                }}
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-12">
              <label htmlFor="qtd_funcionario" className="m-0">
                Qual a quantidade de funcionários na sua empresa?
              </label>
              <Select
                name="qtd_funcionario"
                closeMenuOnSelect
                options={QtdEmployeesOptions}
                noOptionsMessage={() => 'Selecione uma opção'}
                placeholder=""
                onChange={(selected) => {
                  setQtdEmployees(selected?.label as any);
                }}
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-12">
              <label htmlFor="qtd_funcionario" className="m-0">
                Qual faturamento médio mensal?
              </label>
              <Select
                name=""
                closeMenuOnSelect
                options={AverageBillingOptions}
                noOptionsMessage={() => 'Selecione uma opção'}
                placeholder=""
                onChange={(selected) => {
                  setAverageBilling(selected?.label as any);
                }}
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-12">
              <label htmlFor="qtd_funcionario" className="m-0">
                Quanto do faturamento representam as vendas para o Governo?
              </label>
              <Select
                name=""
                closeMenuOnSelect
                options={GovernmentSalePercentageOptions}
                noOptionsMessage={() => 'Selecione uma opção'}
                placeholder=""
                onChange={(selected) => {
                  setGovernmentSale(selected?.label as any);
                }}
              />
            </div>
          </div>
          <div className="row mb-3 text-center">
            <div className="col-md-12">
              {msgErro && <p className="text-danger">Erro ao enviar formulário</p>}
              <button
                type="button"
                className="btn btn-primary"
                disabled={disableButton}
                onClick={() => {
                  handleClick();
                }}
              >
                PROXIMO
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ExperientRegisterModal;
